import React from 'react'
import { SerialNumberSelectListProvider } from './Context'
import { Layout } from './Layout'
import type { SerialNumberSelectListProps } from './types'

export const SerialNumberSelectList = (props: SerialNumberSelectListProps) => {
  return (
    <SerialNumberSelectListProvider {...props}>
      <Layout />
    </SerialNumberSelectListProvider>
  )
}

export * from './types'
export { useSerialNumberSelectListContext } from './Context'
